import React from "react";

const VendorImg = ({ color }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 12.6118C14.7614 12.6118 17 10.3732 17 7.61182C17 4.8504 14.7614 2.61182 12 2.61182C9.23858 2.61182 7 4.8504 7 7.61182C7 10.3732 9.23858 12.6118 12 12.6118Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5901 22.6118C20.5901 18.7418 16.7401 15.6118 12.0001 15.6118C7.26016 15.6118 3.41016 18.7418 3.41016 22.6118"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default VendorImg;
